import { render, staticRenderFns } from "./AddNewCustomer.vue?vue&type=template&id=20226c7c&scoped=true"
import script from "./AddNewCustomer.vue?vue&type=script&lang=js"
export * from "./AddNewCustomer.vue?vue&type=script&lang=js"
import style0 from "./AddNewCustomer.vue?vue&type=style&index=0&id=20226c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20226c7c",
  null
  
)

export default component.exports